module.exports = __webpack_public_path__ + "img/youtube.2a140fff.png";